export default __webpack_public_path__ + "static/ewelinas-6b22c7951bf63acb364b776536fd4278.jpg";